<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible" @click="destroyElement">        
        <div class="tips-modal u-window">           
            <div class="tips-content">
                <div class="item-img" v-if="item_id"><img v-bind:src="src + item_id + '.jpg'"></div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    name : 'tips-app',
    data : function () {
        return {
            visible : false,
            item_id : '',
            src : 'https://web-resource.17m3.com/m3guo/202111/a20211124back/images/tips/',            
        }
    },
    created (){
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
    }    
}
</script>

<style scoped>
    .tips-content{
        width: 7.5rem;
        text-align: center;
    }

    .tips-content img{
        width: 7.5rem;
    }    
</style>


// WEBPACK FOOTER //
// src/components/ItemTips/itemTips.vue